// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__IL8FW","rule":"Divider_rule__3FYw2","label":"Divider_label__1p3CV"};